import React, { useState, useEffect } from "react"
import { Col, Modal, Container, Row, Card, CardBody, Form, Input, FormFeedback, Label } from "reactstrap"
import { connect } from "react-redux"
import { map } from "lodash"
import { withRouter } from "react-router-dom"

import * as backend from "../../helpers/backend_helper"
import Toaster from "../../components/Common/Toaster"
import DeleteAlert from "../../common/ui/customAlert";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";


const OrganizationList = (props: any) => {
  const [modal_standard, setmodal_standard] = useState(false)
  const [lists, setList] = useState<any[]>([])
  const [edit, setEdit] = useState<any>(null)
  const [count, setCount] = useState(true);
  const [deleteAlertVisible, setDeleteAlertVisible] = useState(false)
  const [deleteValue, setDeleteValue] = useState({})

  function tog_standard() {
    setmodal_standard(!modal_standard)
    removeBodyCss()
  }
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  // handleValidSubmit
  const handleValidSubmit = async (values) => {
    if (edit) {
      update(values)
    } else {
      save(values)
    }
  }

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Your Email")
    }),
    onSubmit: (values) => {
      handleValidSubmit(values);
    }
  });

  const update = async values => {
    try {
      await backend.updateOrgs(edit["_id"], values)
      getList()
      tog_standard()
    } catch (e) {
      Toaster.error(typeof e === "string" ? e : "Failed to update organization")
    }
  }
  const save = async values => {
    try {
      await backend.saveOrgs(values)
      getList()
      tog_standard()
    } catch (e) {
      Toaster.error(typeof e === "string" ? e : "Failed to save organization")
    }
  }

  const getList = async () => {
    try {
      const response = await backend.getOrgs()
      setList(response)
    } catch (e) { }
  }

  useEffect(() => {
    if (lists.length == 0 && count) {
      getList()
      setCount(false)
    }
  }, [lists, count])

  //on edit
  const onEdit = (e, value) => {
    e.stopPropagation()
    setEdit(value)
    validation.setValues(value)
    tog_standard()
  }

  // on onDelete
  const onDelete = async (e, value) => {
    e.stopPropagation()

    toggleDeleteAlert()
    setDeleteValue(value)
  }

  const Submit = () => {
    DeleteOrgApi(deleteValue)
    toggleDeleteAlert()
  }

  const toggleDeleteAlert = () => {
    setDeleteAlertVisible(!deleteAlertVisible)
  }

  const DeleteOrgApi = async value => {
    try {
      await backend.deleteOrgs(value["_id"])
      setDeleteValue({})
      getList()
    } catch (e) {
      Toaster.error(typeof e === "string" ? e : "Failed to delete organization")
    }
  }

  //on users
  const onUser = async (e, value) => {
    e.stopPropagation()
    props.history.push(`/orgs/list/${value["_id"]}/users`)
  }

  //rowClick
  const rowClick = async (e, value) => {
    props.history.push(
      `/orgs/list/${value["_id"]}/factory/list?name=${value.name}`
    )
  }



  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="mw-page-header">
            <div className="mw-page-title">
              <h4>Organizations</h4>
              <p>Manage Your Organizations and Their Factories</p>
            </div>
            {props.user && props.user.superAdmin && (
              <button
                type="button"
                onClick={() => {
                  setEdit('')
                  validation.resetForm();
                  tog_standard()
                }}
                className="btn btn-primary"
              >
                <i className="mdi mdi-plus me-1" />
                Create New
              </button>
            )}
          </div>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="p-0">
                  <div className="table-responsive">
                    <table className="mw-table">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th className="text-end">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.length === 0 && (
                          <tr>
                            <td colSpan={2}>
                              <div className="mw-empty-state">
                                <i className="bx bx-buildings" />
                                No organizations yet
                              </div>
                            </td>
                          </tr>
                        )}
                        {map(lists, (list, index) => (
                          <tr
                            onClick={e => rowClick(e, list)}
                            key={index}
                            style={{ cursor: "pointer" }}
                          >
                            <td>
                              <span className="d-inline-flex align-items-center">
                                <span className="mw-avatar-initial">
                                  {(list.name || "?").charAt(0).toUpperCase()}
                                </span>
                                <span style={{ fontWeight: 500 }}>{list.name}</span>
                              </span>
                            </td>
                            <td className="text-end">
                              {list.permission.includes("ADMIN") && (
                                <div className="mw-actions">
                                  <button
                                    type="button"
                                    className="mw-action-btn mw-a-view"
                                    title="Factories"
                                    onClick={e => rowClick(e, list)}
                                  >
                                    <i className="bx bxs-factory" />
                                  </button>
                                  <button
                                    type="button"
                                    className="mw-action-btn mw-a-edit"
                                    title="Edit"
                                    onClick={e => onEdit(e, list)}
                                  >
                                    <i className="bx bx-edit-alt" />
                                  </button>
                                  <button
                                    type="button"
                                    className="mw-action-btn mw-a-users"
                                    title="Users"
                                    onClick={e => onUser(e, list)}
                                  >
                                    <i className="bx bx-user" />
                                  </button>
                                  <button
                                    type="button"
                                    className="mw-action-btn mw-a-delete"
                                    title="Delete"
                                    onClick={e => onDelete(e, list)}
                                  >
                                    <i className="bx bx-trash-alt" />
                                  </button>
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <DeleteAlert
        visible={deleteAlertVisible}
        Title={"Delete Organization"}
        Message={"Do you Want to Delete Organization?"}
        toggleAlert={toggleDeleteAlert}
        Submit={Submit}
      />
      <Modal
        isOpen={modal_standard}
        toggle={() => {
          tog_standard()
        }}
      >
        <Form
          className="form-horizontal"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="myModalLabel">
              {edit ? "Edit Organization" : "Create New Organization"}
            </h5>
            <button
              type="button"
              onClick={() => {
                setmodal_standard(false)
              }}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="form-group mb-0">
              <Label className="form-label">Organization Name</Label>
              <Input
                name="name"
                value={validation.values.name}
                onChange={validation.handleChange}
                className="form-control"
                placeholder="e.g. Clifton Exports"
                type="text"
                autoFocus
                required
              />
              {validation.touched.name && validation.errors.name ? (
                <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
              ) : null}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={() => {
                tog_standard()
              }}
              className="btn btn-light"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
            >
              {edit ? "Save Changes" : "Create"}
            </button>
          </div>
        </Form>
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  const { user } = state.user
  return { user }
}

export default withRouter(connect(mapStateToProps, {})(OrganizationList))
